import React from 'react';
import Layout from '@common/layout';
import Header from '@common/header';
import Footer from '@common/footer';
import Content from '@common/content';
import { PremiumCustomHead } from '@components/common/customHead';

import SubMenu from '../../components/mypage/common/subMenu';
import PremiumInfo from '../../components/mypage/premium/PremiumInfo';
import styles from '../../components/mypage/premium/premium.module.scss';

import useRedirectAfterLogin from '@utils/hooks/useRedirectAfterLogin';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const MyPagePremiumPage = () => {
  useRedirectAfterLogin();

  return (
    <Layout>
      <PremiumCustomHead />
      <Header />
      <Content>
        {/* 마이 페이지 정보 영역 */}
        <div className={cx('wrap')}>
          {/* 좌측 메뉴 영역 */}
          <SubMenu />

          {/* 우측 정보 영역 */}
          <PremiumInfo />
        </div>
      </Content>
      <Footer />
    </Layout>
  );
};

export default MyPagePremiumPage;
